import script from "./DetailDashboardEsgPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailDashboardEsgPage.vue?vue&type=script&setup=true&lang=js"

import "./DetailDashboardEsgPage.vue?vue&type=style&index=0&id=5063db5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5063db5a"]])

export default __exports__